<div class="container">

  <div id="no_access">
    <div class="no_access_image">
      <img src="assets/image/pomodoro-illustration.svg" alt="No Access">
    </div>
    <div class="no_access_title">
      برای استفاده از این قابلیت، باید حساب کاربری خود را ارتقاء دهید!
    </div>
    <div class="no_access_cta">
      <a href="">ارتقاء حساب کاربری</a>
    </div>
  </div>




  <div class="row">
    <button class="btn btn-dark">Push</button>
  </div>
  <div class="row mt-5">
    <div class="col-12 my-5">
      <ngx-charts-bar-vertical-2d
        [view]="viewTwoBar"
        [scheme]="colorSchemeTwoBar"
        [results]="multiTwoBar"
        [xAxis]="showXAxisTwoBar"
        [yAxis]="showYAxisTwoBar"
        [legend]="showLegendTwoBar"
        [showXAxisLabel]="showXAxisLabelTwoBar"
        [showYAxisLabel]="showYAxisLabelTwoBar"
        [xAxisLabel]="xAxisLabelTwoBar"
        [yAxisLabel]="yAxisLabelTwoBar"
        (select)="onSelectTwoBar($event)"
        (activate)="onActivateTwoBar($event)"
        (deactivate)="onDeactivateTwoBar($event)">
      </ngx-charts-bar-vertical-2d>
    </div>
    <div class="col-12 my-5">
      <div class="row" *ngFor="let category of pomodoroRepository.categories">
        {{category}}
      </div>
      <ngx-charts-pie-chart
        [view]="viewCategory"
        [scheme]="colorSchemeCategory"
        [results]="singleCategory"
        [gradient]="gradientCategory"
        [legend]="showLegendCategory"
        [legendPosition]="legendPositionCategory"
        [labels]="showLabelsCategory"
        [doughnut]="isDoughnutCategory"
        (select)="onSelectCategory($event)"
        (activate)="onActivateCategory($event)"
        (deactivate)="onDeactivateCategory($event)"
      >
      </ngx-charts-pie-chart>
    </div>
    <div class="col-12 my-5">
      <ngx-charts-line-chart
        [view]="viewLine"
        [scheme]="colorSchemeLine"
        [legend]="legendLine"
        [showXAxisLabel]="showXAxisLabelLine"
        [showYAxisLabel]="showYAxisLabelLine"
        [xAxis]="xAxisLine"
        [yAxis]="yAxisLine"
        [xAxisLabel]="xAxisLabelLine"
        [yAxisLabel]="yAxisLabelLine"
        [timeline]="timelineLine"
        [results]="multiLine"
        (select)="onSelectLine($event)"
        (activate)="onActivateLine($event)"
        (deactivate)="onDeactivateLine($event)"
      >
      </ngx-charts-line-chart>
    </div>
  </div>
</div>
